import React from "react";
import {
  ipoStatusStyles,
  ipoSubscriptionStatusStyles,
} from "../../../config/data";

const fallbackStyle = { color: "#475467", backgroundColor: "#F2F4F7" };

// Pill for either an offer status or a subscription status; pass
// kind="subscription" for the latter.
function IpoStatusChip({ status, kind = "ipo" }) {
  const styles =
    kind === "subscription" ? ipoSubscriptionStatusStyles : ipoStatusStyles;
  const style = styles[status] || fallbackStyle;

  return (
    <span
      style={{
        display: "inline-block",
        padding: "0 10px",
        height: "22px",
        borderRadius: "10px",
        textAlign: "center",
        lineHeight: "22px",
        fontSize: "12px",
        fontWeight: 500,
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {(status || "-").replace(/_/g, " ")}
    </span>
  );
}

export default IpoStatusChip;
